module.exports = __webpack_public_path__ + "ss.3c65b7fb0dc06aa7b6da.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/ss.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/ss.svg
// module chunks = styles